import React from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ title, content, image, category, id }) => {
    // Add default values to prevent destructuring errors
    if (!title || !content) {
        return null; // Don't render anything if required props are missing
    }
    

    return (
        <div style={styles.card}>
            <div style={styles.imageContainer}>
                <img src={image || '/images/placeholder.jpg'} alt={title} style={styles.image} />
                {category && (
                    <div style={styles.categoryBadge}>
                        {category.charAt(0).toUpperCase() + category.slice(1)}
                    </div>
                )}
                <div style={styles.overlay}>
                    <Link to={`/products/${id || productSlug}`} style={styles.link}>
                        <button style={styles.quickViewButton}>
                            <i className="fas fa-eye" style={{ marginRight: '8px' }}></i>
                            Quick View
                        </button>
                    </Link>
                </div>
            </div>
            <div style={styles.content}>
                <h3 style={styles.title}>{title}</h3>
                <p style={styles.description}>
                    {content.length > 100 ? `${content.substring(0, 100)}...` : content}
                </p>
                <div style={styles.features}>
                    {category === "residential" && (
                        <>
                            <span style={styles.featureTag}><i className="fas fa-home"></i> Residential</span>
                            <span style={styles.featureTag}><i className="fas fa-award"></i> Premium</span>
                        </>
                    )}
                    {category === "commercial" && (
                        <>
                            <span style={styles.featureTag}><i className="fas fa-building"></i> Commercial</span>
                            <span style={styles.featureTag}><i className="fas fa-tachometer-alt"></i> High Speed</span>
                        </>
                    )}
                    {category === "industrial" && (
                        <>
                            <span style={styles.featureTag}><i className="fas fa-industry"></i> Industrial</span>
                            <span style={styles.featureTag}><i className="fas fa-weight-hanging"></i> Heavy Duty</span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

const styles = {
    card: {
        width: '100%',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid rgba(229, 231, 235, 0.5)',
        '&:hover': {
            transform: 'translateY(-10px)',
            boxShadow: '0 15px 35px rgba(22, 59, 162, 0.15)',
        },
        '&:hover img': {
            transform: 'scale(1.1)',
        }
    },
    imageContainer: {
        width: '100%',
        height: '220px',
        overflow: 'hidden',
        position: 'relative',
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transition: 'transform 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(22, 59, 162, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0,
        transition: 'opacity 0.4s ease',
        '&:hover': {
            opacity: 1,
        }
    },
    quickViewButton: {
        padding: '12px 24px',
        backgroundColor: 'white',
        color: '#163ba2',
        border: 'none',
        borderRadius: '30px',
        cursor: 'pointer',
        fontWeight: '600',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)',
        transition: 'transform 0.3s ease',
        '&:hover': {
            transform: 'scale(1.05)'
        }
    },
    content: {
        padding: '25px',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    title: {
        fontSize: '1.4rem',
        marginBottom: '12px',
        color: '#2c3e50',
        fontWeight: '700',
    },
    description: {
        fontSize: '1rem',
        color: '#64748b',
        marginBottom: '20px',
        lineHeight: '1.6',
    },
    button: {
        padding: '12px 24px',
        backgroundColor: '#163ba2',
        color: 'white',
        border: 'none',
        borderRadius: '30px',
        cursor: 'pointer',
        fontWeight: '600',
        transition: 'all 0.3s ease',
        marginTop: 'auto',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 5px 15px rgba(22, 59, 162, 0.2)',
        '&:hover': {
            backgroundColor: '#0f2875',
            transform: 'translateY(-3px)',
            boxShadow: '0 8px 20px rgba(22, 59, 162, 0.3)',
        }
    },
    link: {
        textDecoration: 'none',
        display: 'inline-block',
        width: '100%',
    },
    categoryBadge: {
        position: 'absolute',
        top: '15px',
        right: '15px',
        backgroundColor: 'rgba(22, 59, 162, 0.9)',
        color: 'white',
        padding: '6px 12px',
        borderRadius: '20px',
        fontSize: '0.8rem',
        fontWeight: '600',
        boxShadow: '0 3px 8px rgba(0, 0, 0, 0.15)',
        zIndex: 2,
    },
    features: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        marginBottom: '25px',
    },
    featureTag: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        fontSize: '0.8rem',
        fontWeight: '500',
        padding: '5px 10px',
        backgroundColor: '#f1f5f9',
        color: '#475569',
        borderRadius: '15px',
    }
};

export default ProductCard;